/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import React from 'react'

/** A description of the available properties for this component. */
type FilterSelectProps = {
  /** The label for the select input. */
  label: string

  /** The current value of the select input. */
  value: string | undefined

  /** The function to call when the select input changes. */
  onChange: (value: string) => void

  /** Whether the select input is disabled. */
  disabled?: boolean

  /** The children to render in the select input. */
  children: React.ReactNode
}

/**
 * A select input, used for filtering in the qualities explorer.
 */
const FilterSelect: React.FC<FilterSelectProps> = ({ label, value, onChange, disabled, children }) => {
  return (
    <div className={'w-full sm:w-max'}>
      <label className={'sr-only'}>{label}</label>
      <div className={'relative inline-block w-full sm:w-max'}>
        <select
          className={
            'w-full sm:w-max py-4 pl-6 pr-12 border-2 border-primary-500 rounded-full bg-white text-primary-500 font-medium appearance-none'
          }
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          {children}
        </select>
        <div className={'pointer-events-none absolute inset-y-0 right-6 flex items-center'}>
          <svg className={'h-4 w-4 text-primary-500'} fill={'none'} stroke={'currentColor'} viewBox={'0 0 24 24'}>
            <path strokeLinecap={'round'} strokeLinejoin={'round'} strokeWidth={'2'} d={'M19 9l-7 7-7-7'} />
          </svg>
        </div>
      </div>
    </div>
  )
}

export { FilterSelect }
